import React from "react";
import {Card, CardContent, Grid, Paper, Typography} from "@mui/material";
import CustomTable from "../core/CustomTable";
import moment from "moment";
import {isInsurerUser} from "../../constants/UserAuth";

function SummaryTab(props) {
    const {claimData, billSummaryColumn, billTotal} = props;
    return (
        <Paper
            style={{
                //   margin: "2rem 1.5rem",
                display: "flex",
                flexDirection: "column",
                gap: 20,
                padding: "2rem",
            }}
        >
            <Grid sx={{minWidth: 275}}>
                <Grid
                    className="flex-container"
                    style={{
                        gap: 20,
                        textAlign: "center",
                        alignItems: "space-evenly",
                    }}
                >
                    <Card className="flex-box">
                        <Typography
                            variant="body1"
                            component={"p"}
                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                        >
                            Claim Bill Amount Requested
                        </Typography>
                        <Typography variant="subTitle1" component={"p"}>
                            &#x20b9;{" "}
                            {claimData?.claimBillAmountRequested === undefined ||
                            claimData?.claimBillAmountRequested === null
                                ? "0"
                                : claimData.claimBillAmountRequested.toLocaleString("en-IN")}
                        </Typography>
                    </Card>
                    <Card className="flex-box">
                        <Typography
                            variant="body1"
                            component={"p"}
                            sx={{fontSize: "14px", color: "#B1B3B3"}}
                        >
                            Amount After Tariff Application
                        </Typography>
                        <Typography variant="subTitle1" component={"p"}>
                            &#x20b9;{" "}
                            {claimData?.amountAfterTariffApplication === undefined ||
                            claimData?.amountAfterTariffApplication === null
                                ? " 0"
                                : claimData.amountAfterTariffApplication.toLocaleString(
                                    "en-IN"
                                )}
                        </Typography>
                    </Card>
                    <Card className="flex-box">
                        <Typography
                            variant="body1"
                            component={"p"}
                            sx={{fontSize: "14px", color: "#B1B3B3"}}
                        >
                            Amount After Policy Rules Application
                        </Typography>
                        <Typography variant="subTitle1" component={"p"}>
                            &#x20b9;{" "}
                            {claimData?.amountAfterPolicyrulesApplication === undefined ||
                            claimData?.amountAfterPolicyrulesApplication === null
                                ? " 0"
                                : claimData.amountAfterPolicyrulesApplication.toLocaleString(
                                    "en-IN"
                                )}
                        </Typography>
                    </Card>
                    <Card className="flex-box">
                        <Typography
                            variant="body1"
                            component={"p"}
                            sx={{fontSize: "14px", color: "#B1B3B3"}}
                        >
                            Amount After Medical Admissibility
                        </Typography>
                        <Typography variant="subTitle1" component={"p"}>
                            &#x20b9;{" "}
                            {claimData?.amountAfterMedicalAdmissibility === undefined ||
                            claimData?.amountAfterMedicalAdmissibility === null
                                ? "0"
                                : claimData.amountAfterMedicalAdmissibility.toLocaleString(
                                    "en-IN"
                                )}
                        </Typography>
                    </Card>
                </Grid>
            </Grid>
            {
                claimData?.billIdentifier && claimData?.billFound &&
                <Grid>
                    <Typography
                        variant="subTitle1"
                        component={"p"}
                        style={{
                            textAlign: "center",
                            fontFamily: "'Nunito', sans-serif",
                            fontWeight: 900,
                            fontSize: "24px",
                        }}
                    >
                        Bills, Tariff and PML
                    </Typography>

                    <Grid style={{marginTop: "10px"}}>
                        <CustomTable
                            tableColumns={billSummaryColumn || []}
                            tableData={
                                claimData &&
                                claimData.tariffPmlDataMerged &&
                                claimData.tariffPmlDataMerged.billTariffPmlAmountList !== null
                                    ? claimData?.tariffPmlDataMerged["billTariffPmlAmountList"]
                                    : []
                            }
                            isPagination={false}
                        />
                    </Grid>
                    <Grid>
                        {claimData?.tariffPmlDataMerged?.billTariffPmlAmountList && (
                            <CustomTable
                                tableColumns={billTotal}
                                tableData={[
                                    {
                                        totalBill:
                                            claimData.tariffPmlDataMerged["billTariffPmlAmountList"][
                                                "total_bill_amount"
                                                ] === null
                                                ? 0
                                                : claimData.tariffPmlDataMerged["total_bill_amount"],
                                        totalParsed:
                                            claimData.tariffPmlDataMerged["billTariffPmlAmountList"][
                                                "total_tariff_admissible_amount"
                                                ] === null
                                                ? 0
                                                : claimData.tariffPmlDataMerged[
                                                    "total_tariff_admissible_amount"
                                                    ],
                                        totalPML:
                                            claimData.tariffPmlDataMerged["billTariffPmlAmountList"][
                                                "total_pml_admissible_amount"
                                                ] === null
                                                ? 0
                                                : claimData.tariffPmlDataMerged[
                                                    "total_pml_admissible_amount"
                                                    ],
                                        totalSavings:
                                            claimData.tariffPmlDataMerged["billTariffPmlAmountList"][
                                                "total_deduction"
                                                ] === null
                                                ? 0
                                                : claimData.tariffPmlDataMerged["total_deduction"],
                                    },
                                ]}
                                isPagination={false}
                            />
                        )}
                    </Grid>
                </Grid>
            }
            <Grid
                container
                style={{
                    marginTop: "30px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "space-evenly",
                    gap: 12,
                }}
            >
                {
                    // !claimData?.discharge &&
                    <Grid
                        container
                        style={{
                            marginTop: "30px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "space-evenly",
                            gap: 12,
                        }}
                    >
                        <Card sx={{minWidth: 275}}>
                            <CardContent>
                                <Typography
                                    sx={{
                                        fontSize: 20,
                                        fontWeight: 900,
                                        fontFamily: '"Nunito", sans-serif',
                                    }}
                                    gutterBottom
                                >
                                    {!claimData?.discharge ? 'Preauth / Interim' : 'Discharge'} Adjudication :
                                </Typography>
                                <Typography variant="h5" component="div"></Typography>

                                <Grid style={{display: "flex", gap: 30}}>
                                    <Typography variant="subTitle1" component={"p"}>
                                        Decision :
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {claimData["claimStatus"] !== undefined && claimData["claimStatus"] !== null
                                            ? claimData["claimStatus"].replaceAll('_', ' ')
                                            : "Awaiting Response"}
                                    </Typography>
                                </Grid>

                                <Grid style={{display: "flex", gap: 30}}>
                                    <Typography variant="subTitle1" component={"p"}>
                                        Comment :
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {claimData["claimRemarks"] !== null
                                            ? claimData["claimRemarks"]
                                            : "Awaiting Response"}
                                    </Typography>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                }
                {/* Medical Admissibility card */}
                {
                    claimData?.medicalIdentifier &&
                    <Card sx={{minWidth: 275}}>
                        <CardContent>
                            <Typography
                                sx={{
                                    fontSize: 20,
                                    fontWeight: 900,
                                    fontFamily: '"Nunito", sans-serif',
                                }}
                                gutterBottom
                            >
                                Medical Admissibility :
                            </Typography>
                            <Typography variant="h5" component="div"></Typography>

                            <Grid style={{display: "flex", gap: 30}}>
                                <Typography variant="subTitle1" component={"p"}>
                                    Decision :
                                </Typography>
                                <Typography variant="subTitle1" component={"p"}>
                                    {claimData["vneuronDecision"] !== undefined && claimData["vneuronDecision"] !== null
                                        ? claimData["vneuronDecision"].replaceAll('_', ' ')
                                        : "Awaiting Response"}
                                </Typography>
                            </Grid>

                            <Grid style={{display: "flex", gap: 30}}>
                                <Typography variant="subTitle1" component={"p"}>
                                    Comment :
                                </Typography>
                                <Typography variant="subTitle1" component={"p"}>
                                    {claimData["vneuronRemarks"] !== null
                                        ? claimData["vneuronRemarks"]
                                        : "Awaiting Response"}
                                </Typography>
                            </Grid>
                        </CardContent>
                    </Card>
                }
                {/* Coverage Result card */}
                <Card sx={{minWidth: 275}}>
                    {claimData?.pmlIdentifier && (
                        <CardContent>
                            <Typography
                                sx={{
                                    fontSize: 20,
                                    fontWeight: 900,
                                    fontFamily: '"Nunito", sans-serif',
                                }}
                                gutterBottom
                            >
                                Policy Coverage Results :
                            </Typography>
                            <Typography variant="h5" component="div"></Typography>
                            <Typography
                                variant="subTitle1"
                                component={"p"}
                                sx={{fontSize: 18, fontWeight: 700}}
                            >
                                {claimData?.pmlClaimResult?.claim_result?.coverageReasons
                                    ?.length > 0
                                    ? "Passed Rules :"
                                    : null}
                            </Typography>
                            <Typography variant="subTitle1" component={"div"}>
                                <ol>
                                    {claimData?.pmlClaimResult?.coverageReasons.map((reason) => (
                                        <li key={reason} style={{color: "green"}}>
                                            {reason}
                                        </li>
                                    ))}
                                </ol>
                            </Typography>
                            <Typography
                                variant="subTitle1"
                                component={"p"}
                                sx={{fontSize: 18, fontWeight: 700}}
                            >
                                {claimData?.pmlClaimResult?.coverageFailedReasons?.length > 0
                                    ? "Applicable Policy Clause for Rejections"
                                    : null}
                            </Typography>
                            <Typography variant="subTitle1" component={"div"}>
                                <ol>
                                    {claimData?.pmlClaimResult?.coverageFailedReasons.map(
                                        (reason) => (
                                            <li key={reason} style={{color: "red"}}>
                                                {reason}
                                            </li>
                                        )
                                    )}
                                </ol>
                            </Typography>

                            {/* Benefit Group Resutl card */}
                            {/* {claimData?.pmlClaimResult?.benefit_results.length > 0 ? (
                      <Grid>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            fontFamily: '"Nunito", sans-serif',
                          }}
                          gutterBottom
                        >
                          Category Results :
                        </Typography>
                        <Typography variant="h5" component="div"></Typography>

                        <Typography>
                          {claimData?.pmlClaimResult?.benefit_results.map((result) => (
                            <Accordion key={result.benefit_group}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography
                                  sx={{
                                    fontFamily: '"Nunito", sans-serif',
                                    fontWeight: 700,
                                  }}
                                >
                                  {result.benefit_group}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Typography variant="body2">
                                  <Grid className="flex-container">
                                    <Typography
                                      variant="subTitle1"
                                      component={"p"}
                                      className="flex-box"
                                      sx={{
                                        fontFamily: '"Nunito", sans-serif',
                                        fontSize: 16,
                                      }}
                                    >
                                      {result["benefit_covered"] === true
                                        ? "Covered : True"
                                        : "Covered : False"}
                                    </Typography>
                                    <Typography
                                      variant="subTitle1"
                                      component={"p"}
                                      className="flex-box"
                                      sx={{
                                        fontFamily: '"Nunito", sans-serif',
                                        fontSize: 16,
                                      }}
                                    >
                                      Admissible amount (after policy rules) :{" "}
                                      {result.benefit_group_admissible_amount}
                                    </Typography>
                                    <Typography
                                      variant="subTitle1"
                                      component={"p"}
                                      className="flex-box"
                                      sx={{
                                        fontFamily: '"Nunito", sans-serif',
                                        fontSize: 16,
                                      }}
                                    >
                                      Admissible amount (after tariff):{" "}
                                      {result.benefit_group_claimed_amount}
                                    </Typography>
                                  </Grid>
                                  <Typography
                                    variant="subTitle1"
                                    component={"p"}
                                  >
                                    {result.coverageReasons.length > 0
                                      ? "Covered Rules"
                                      : null}
                                  </Typography>
                                  <ol>
                                    {result?.coverageReasons.map((pass) => (
                                      <li key={pass} style={{ color: "green" }}>
                                        {pass}
                                      </li>
                                    ))}
                                  </ol>
                                  <Typography
                                    variant="subTitle1"
                                    component={"p"}
                                  >
                                    {result.coverageFailedReasons.length > 0
                                      ? "Applicable Policy Clause for Rejections"
                                      : null}
                                  </Typography>
                                  <ol>
                                    {result?.coverageFailedReasons.map(
                                      (fail) => (
                                        <li key={fail} style={{ color: "red" }}>
                                          {fail}
                                        </li>
                                      )
                                    )}
                                  </ol>
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Typography>
                      </Grid>
                    ) : null} */}
                        </CardContent>
                    )}
                </Card>
                {claimData.pmlsuccess === false ? (
                    <Card sx={{minWidth: 275}}>
                        <CardContent>
                            <Typography
                                sx={{
                                    fontSize: 20,
                                    fontWeight: 900,
                                    fontFamily: '"Nunito", sans-serif',
                                }}
                                gutterBottom
                            >
                                Important Dates :
                            </Typography>
                            <Grid
                                className="flex-container"
                                style={{
                                    gap: 20,
                                    textAlign: "center",
                                    alignItems: "space-evenly",
                                }}
                            >
                                <Card className="flex-box">
                                    <Typography
                                        variant="body1"
                                        component={"p"}
                                        sx={{
                                            fontSize: "15px",

                                            color: "#B1B3B3",
                                        }}
                                    >
                                        Date Of Admission
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {isInsurerUser() ? moment(claimData?.dateOfAdmission).format(
                                            "DD-MM-YYYY"
                                        ) : moment(claimData?.dateOfAdmission).format(
                                            "DD-MM-YYYY, h:mm a"
                                        )}
                                    </Typography>
                                </Card>
                                <Card className="flex-box">
                                    <Typography
                                        variant="body1"
                                        component={"p"}
                                        sx={{fontSize: "15px", color: "#B1B3B3"}}
                                    >
                                        Date Of First Diagnosis
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {isInsurerUser() ? moment(claimData?.dateOfFirstDiagnosis).format(
                                            "DD-MM-YYYY"
                                        ) : moment(claimData?.dateOfFirstDiagnosis).format(
                                            "DD-MM-YYYY, h:mm a"
                                        )}
                                    </Typography>
                                </Card>
                                <Card className="flex-box">
                                    <Typography
                                        variant="body1"
                                        component={"p"}
                                        sx={{fontSize: "15px", color: "#B1B3B3"}}
                                    >
                                        Policy Inception Date
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {isInsurerUser() ? moment(claimData?.policyInceptionDate).format(
                                            "DD-MM-YYYY"
                                        ) : moment(claimData?.policyInceptionDate).format(
                                            "DD-MM-YYYY, h:mm a"
                                        )}
                                    </Typography>
                                </Card>
                                <Card className="flex-box">
                                    <Typography
                                        variant="body1"
                                        component={"p"}
                                        sx={{fontSize: "15px", color: "#B1B3B3"}}
                                    >
                                        Policy Start Date
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {isInsurerUser() ? moment(claimData?.policyStartDate).format(
                                            "DD-MM-YYYY"
                                        ) : moment(claimData?.policyStartDate).format(
                                            "DD-MM-YYYY, h:mm a"
                                        )}
                                    </Typography>
                                </Card>
                                <Card className="flex-box">
                                    <Typography
                                        variant="body1"
                                        component={"p"}
                                        sx={{fontSize: "15px", color: "#B1B3B3"}}
                                    >
                                        Policy End Date
                                    </Typography>
                                    <Typography variant="subTitle1" component={"p"}>
                                        {isInsurerUser() ? moment(claimData?.policyEndDate).format(
                                            "DD-MM-YYYY"
                                        ) : moment(claimData?.policyEndDate).format(
                                            "DD-MM-YYYY, h:mm a"
                                        )}
                                    </Typography>
                                </Card>
                            </Grid>
                        </CardContent>
                    </Card>
                ) : null}
            </Grid>
        </Paper>
    );
}

export default SummaryTab;
